/**
 * notifyr.ts - Notifyr (Notifications) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1540 [pending] danielbeer: Added package metadata
 * - 251023_1854 [pending] danielbeer: Initial creation
 */

export const notifyrModule = {
  id: 'system-notifyr',
  name: 'Notifications',
  icon: '🔔',
  category: 'modules',
  order: 3,
  
  // Package metadata for info panel
  packageInfo: {
    name: '@opcentral/notifyr',
    version: '1.0.0',
    displayVersion: '0.2.0',
    description: 'Universal notification system for OpCentral',
    status: 'implemented',
    implementationProgress: 80,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      'react': '^18.0.0'
    },
    keywords: ['notifications', 'email', 'sms', 'webhook', 'push', 'in-app'],
    author: 'OpCentral',
    license: 'MIT'
  },
  
  settings: {
    enableNotifications: {
      type: 'boolean',
      label: 'Enable Notifications',
      description: 'Show notifications for important events',
      defaultValue: true
    },
    
    notificationSound: {
      type: 'boolean',
      label: 'Notification Sound',
      description: 'Play sound when notifications appear',
      defaultValue: true,
      visible: (settings) => settings['system-notifyr.enableNotifications']
    },
    
    notificationPosition: {
      type: 'select',
      label: 'Notification Position',
      description: 'Where notifications appear on screen',
      defaultValue: 'top-right',
      options: [
        { label: 'Top Left', value: 'top-left' },
        { label: 'Top Right', value: 'top-right' },
        { label: 'Bottom Left', value: 'bottom-left' },
        { label: 'Bottom Right', value: 'bottom-right' },
        { label: 'Top Center', value: 'top-center' },
        { label: 'Bottom Center', value: 'bottom-center' }
      ],
      visible: (settings) => settings['system-notifyr.enableNotifications']
    },
    
    notificationDuration: {
      type: 'number',
      label: 'Display Duration (seconds)',
      description: 'How long notifications stay visible',
      defaultValue: 5,
      min: 1,
      max: 30,
      visible: (settings) => settings['system-notifyr.enableNotifications']
    },
    
    emailNotifications: {
      type: 'boolean',
      label: 'Email Notifications',
      description: 'Send notifications via email',
      defaultValue: false
    },
    
    pushNotifications: {
      type: 'boolean',
      label: 'Push Notifications',
      description: 'Send browser push notifications',
      defaultValue: false
    },
    
    doNotDisturb: {
      type: 'boolean',
      label: 'Do Not Disturb',
      description: 'Temporarily disable all notifications',
      defaultValue: false
    }
  }
};

export default notifyrModule;
